import { formatInput } from ".";

const ninFormatRegex = /^(\d{1,6})(\s?)(\d{0,5})/;

export function formatNin(nin: string): string {
  return formatInput(nin, ninFormatRegex);
}
